import React, { Component } from 'react';
import { changeModel, createModel, deleteModel } from "../../../../api/apiRequests";
import { SliderPicker } from 'react-color';
import MyInput from "../../../shared/form/MyInput";
import MyTextArea from "../../../shared/form/MyTextArea";
import Prices from "./Prices";
import MySubmit from "../../../shared/form/MySubmit";
import scooter from "./../../../../media/icons/scooter.svg"
import PieceOfInfo from "../../../shared/PieceOfInfo";
import add from "./../../../../media/icons/add.svg"
import { ToolTip } from "../../../shared/allToolTips";
import DragAndDropUpload from "../../../shared/DragAndDropUpload";
import MyCheckBox from "../../../shared/form/MyCheckBox";
import camion from "../../../../media/icons/camion.svg";

const emptyValues = [null, undefined, '']
const isEmpty = v => emptyValues.includes(v)

class ModalModel extends Component {

  state = {
    name: this.props.model ? this.props.model.name : "",
    cubicCapacity: this.props.model ? this.props.model.cubicCapacity : "",
    image: this.props.model ? this.props.model.image : { main: "", tc: "", others: [] },
    requiredLicense: this.props.model ? this.props.model.requiredLicense : "",
    power: this.props.model ? this.props.model.power : "",
    environmentalPerformance: this.props.model ? this.props.model.environmentalPerformance : "",
    depositCapacity: this.props.model ? this.props.model.depositCapacity : "",
    info: this.props.model ? this.props.model.info : { es: "", en: "" },
    color: this.props.model ? this.props.model.color : "#606060",
    seasonRate: this.props.model ? this.props.model.seasonRate : [{
      startMonth: 1,
      endMonth: 12,
      pricing: [0, 30, 30, 30, 30, 30, 30],
      extra: 30
    }],
    allowsDelivery: this.props.model ? !!(this.props.model.deliveryPrice || this.props.model.deliveryPricePalma) : false,
    deliveryPrice: this.props.model ? isEmpty(this.props.model.deliveryPrice) ? null : this.props.model.deliveryPrice : null,
    deliveryPricePalma: this.props.model ? isEmpty(this.props.model.deliveryPricePalma) ? null : this.props.model.deliveryPricePalma : null,
  };
  errors = [];

  componentDidUpdate (prevProps, prevState) {
    if (!this.state.allowsDelivery && (this.state.deliveryPrice !== null || this.state.deliveryPricePalma !== null)) {
      this.setState({ deliveryPrice: null, deliveryPricePalma: null });
    }
  }


  captureErrors = (where, isCorrect) => {
    const indice = this.errors.indexOf(where);
    const existsIndice = indice >= 0;
    isCorrect ? (existsIndice && this.errors.splice(indice, 1)) : (!existsIndice && this.errors.push(where));
  };

  changeInfo = (event) => {
    this.setState({
      [event.target.name]: (event.target.value)
    });
  }

  changeImg = (event) => {
    this.setState({ image: { ...this.state.image, [event.target.name]: (event.target.value) } })
  };

  changeSecondaryInfo = (event) => {
    this.setState({ info: { ...this.state.info, [event.target.name]: (event.target.value) } })
  };

  changePriceRates = (seasonRate) => {
    this.setState({ seasonRate })
  };

  addRate = () => {
    const { seasonRate } = this.state;
    seasonRate.unshift({
      startMonth: 1,
      endMonth: 12,
      pricing: [0, 30, 30, 30, 30, 30, 30],
      extra: 30
    });
    this.changePriceRates(seasonRate)
  };


  submit = (event) => {
    event.preventDefault();
    if (this.errors.length < 1) {
      const { id } = this.props;
      id ? this.update() : this.create()
    } else {
      alert("Todos los campos son obligatorios")
    }
  };

  create = () => {
    const { updateModels, changeModal } = this.props;
    createModel(this.state)
    .then(() => {
      updateModels();
      changeModal(null);
      alert("Se ha creado correctamente el uevo modelo")
    }).catch(() => {
      alert("¡Ups!, No se ha podido efectuar la creación de un nuevo modelo")
    })
  };

  update = () => {
    const { id, updateRentals, updateModels, changeModal } = this.props;
    changeModel(id, this.state)
    .then(() => {
      updateModels();
      updateRentals();
      changeModal(null);
      alert("Se ha actualizado correctamente");
    }).catch(() => {
      alert("¡Ups!, No se ha podido efectuar la actualización")
    })
  };

  delete = (event) => {
    event.preventDefault();
    const { id, updateRentals, updateModels, changeModal } = this.props;
    deleteModel(id)
    .then(() => {
      alert("Se ha eliminado el modelo correctamente");
      updateModels();
      updateRentals();
      changeModal(null);
    }).catch(() => {
      alert("¡Ups!, No se ha podido efectuar la eliminación")
    })
  };

  colorChange = (color) => {
    this.setState({ color: color.hex });
  };

  handleDropImg = (e, file, targetName) => {
    const reader = new FileReader();

    if (!file.type.match("image/*")) {
      alert('Formato inválido');
      return;
    }
    reader.onload = () => {
      this.setState({ image: { ...this.state.image, [targetName]: (reader.result) } })
    };
    reader.readAsDataURL(file);
  };


  render() {
    const info = this.state;
    const { id } = this.props;
    return (
      <React.Fragment>
        <ToolTip.ModelImgMain/>
        <ToolTip.ModelImgTc/>
        <div className="bg-white p-5"
             style={{ minWidth: "300px", width: "90vw", maxWidth: "1500px", minHeight: "200px" }}>
          <form onSubmit={this.submit} className="row">
            <div className="col-12 col-lg-6">
              <div style={{ top: 40 }} data-tip={true} data-for='modelImgMain'
                   className="row position-sticky justify-content-center border border-light no-gutters">
                <DragAndDropUpload height="300px" handleDrop={(e, file) => this.handleDropImg(e, file, "main")}>
                  <img height="100%" style={{ maxWidth: "100%" }}
                       src={info.image.main ? info.image.main : scooter} alt=""/>
                </DragAndDropUpload>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <MyInput title="Nombre" type="text" name="name" value={info.name}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={12}/>
                </div>
                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <MyInput title="Cilindrada (ccc)" type="number" name="cubicCapacity" value={info.cubicCapacity}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={5}/>
                </div>
              </div>
              <div data-tip={true} data-for='modelImgTc' className="row">
                <DragAndDropUpload height="150px" handleDrop={(e, file) => this.handleDropImg(e, file, "tc")}>
                  {info.image.tc ?
                    <img height="100%" style={{ maxWidth: "100%" }}
                         src={info.image.tc ? info.image.tc : scooter} alt=""/> :
                    "Arrastra la imagen del Top Case"
                  }
                </DragAndDropUpload>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <MyInput title="Licencia" type="text" name="requiredLicense" value={info.requiredLicense}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={20}/>
                </div>
                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <MyInput title="Caballos" type="text" name="power" value={info.power}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={30}/>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <MyInput title="Rendimiento ambiental" type="text" name="environmentalPerformance"
                           value={info.environmentalPerformance}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={20}/>
                </div>
                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <MyInput title="Capacidad de deposito" type="text" name="depositCapacity" value={info.depositCapacity}
                           onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={30}/>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <MyTextArea title="Información adicional (es)" type="text" name="es" value={info.info.es}
                              onChange={this.changeSecondaryInfo} captureErrors={this.captureErrors} notEmpty={true}/>
                </div>
                <div className="col-12">
                  <MyTextArea title="Información adicional (en)" type="text" name="en" value={info.info.en}
                              onChange={this.changeSecondaryInfo} captureErrors={this.captureErrors} notEmpty={true}/>
                </div>
              </div>

              <PieceOfInfo title="COLOR"/>
              <div className="row my-3">
                <div className="col-12 p-0">
                  <SliderPicker color={info.color} onChangeComplete={this.colorChange}/>
                </div>
              </div>


              <PieceOfInfo title="Entrega / Recogida" />
              <div className="row">
                <div className="col-12">
                  <div className="row form-check">
                    <MyCheckBox title="Permite entrega/recogida" img={camion}
                                name="allowsDelivery" value={info.allowsDelivery}
                                onChange={this.changeInfo} className="mr-md-2"/>
                  </div>
                </div>
              </div>
              {info.allowsDelivery &&
                <React.Fragment>
                  <div className="row p-2 pt-3 bg-light">
                    <div className="col">
                      <MyInput title="Precio afueras" type="number" name="deliveryPrice" value={info.deliveryPrice === null ? "" : info.deliveryPrice}
                               onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty minChar={1} maxChar={3}/>
                    </div>
                    <div className="col">
                      <MyInput title="Precio palma" type="number" name="deliveryPricePalma" value={info.deliveryPricePalma === null ? "" : info.deliveryPricePalma}
                               onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty minChar={1} maxChar={3}/>
                    </div>
                  </div>
                </React.Fragment>
              }

              <PieceOfInfo title="TEMPORADAS">
                <img style={{ cursor: "pointer" }} onClick={this.addRate} className="align-self-end ml-auto p-1"
                     width="24px" height="24px" src={add} alt=""/>
              </PieceOfInfo>
              <div className="row mt-3">
                <Prices priceRates={info.seasonRate} changePriceRates={this.changePriceRates}
                        captureErrors={this.captureErrors}/>
              </div>
              <div className="row mt-3">
                {id && <div className="col">
                  <div className="row">
                    <MySubmit type="" onClick={this.delete} className="bg-danger" text="ELIMINAR"/>
                  </div>
                </div>}
                <div className="col">
                  <div className="row">
                    <MySubmit className="col bg-primary" text={id ? "ACTUALIZAR" : "CREAR"}/>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

export default ModalModel;
